module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en_US.json
// module id = hVFC
// module chunks = 12